import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/myimg_upload.svg'
import _imports_1 from '@/assets/svg/img_list_null.svg'


const _withScopeId = n => (_pushScopeId("data-v-6bd1db9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "模块标题：", -1))
const _hoisted_3 = { class: "setup_input_length" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imglist_show border-top" }, [
  /*#__PURE__*/_createElementVNode("p", null, "图片展示"),
  /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "添加图片：最多可添加40个，可拖拽图片排序")
], -1))
const _hoisted_5 = { class: "padding" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 图片可以无限添加，最多显示的设置只显示在H5页面展示的数量，最多设置5个展示位，超过5张图片H5展示更多按钮（设置2-3个展示位，添加4张图片可显示更多按钮，同理设置2-3个展示位直播间只添加2-3个不会显示更多按钮） ", -1))
const _hoisted_7 = { class: "upd_box" }
const _hoisted_8 = {
  key: 1,
  class: "icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "本地上传", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "title img_style_box padding" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "排列方式", -1))
const _hoisted_13 = { class: "flex img_style" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "style_set" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "标题：", -1))
const _hoisted_17 = { class: "set_info border-top flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "颜色：", -1))
const _hoisted_19 = { class: "set_color flex between" }
const _hoisted_20 = { class: "style_set" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "背景：", -1))
const _hoisted_22 = { class: "set_info border-top border-bottom" }
const _hoisted_23 = { class: "flex between" }
const _hoisted_24 = { class: "default_color flex between" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex between" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义背景色：", -1))
const _hoisted_28 = { class: "set_color flex between" }
const _hoisted_29 = { class: "flex between modal_top" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red_color" }, "*", -1))
const _hoisted_32 = { class: "modal_bottom" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red_color" }, "*"),
  /*#__PURE__*/_createTextVNode("图片信息：")
], -1))
const _hoisted_34 = {
  key: 1,
  class: "img_list_null"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_36 = {
  key: 2,
  class: "modal_img_list modal_w_box"
}
const _hoisted_37 = {
  key: 1,
  class: "icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "本地上传", -1))
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "hover_bottom" }

import { Tabs, Radio, InputNumber, Tooltip, Upload, message, Modal, Select, Pagination } from 'ant-design-vue';
import { QuestionCircleFilled, LoadingOutlined } from '@ant-design/icons-vue';
import { ref, reactive, watch } from 'vue';
import emitter from '@/utils/mitt';
import { ElColorPicker } from 'element-plus';
import CIconModal from '@/views/gateway/cubNav/iconModal.vue';
import { VueDraggableNext } from 'vue-draggable-next';
import http from '@/api/conentCenter/communal';
import router from '@/router';
import { getToken } from '@/plugins/cookie';
import CLoading from '@/components/CLoading.vue';
import { colorList, uploadNow } from './PublicFunction';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';

interface menuItem {
  id: number;
  name: string;
  visible: boolean;
  count: number;
  default: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyImages_setup',
  props: {
  custom: {},
  labelId: {},
},
  setup(__props) {

const props: any = __props;

const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aInputNumber = InputNumber;
const aTooltip = Tooltip;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aUpload = Upload;
const aModal = Modal;
const aSelect = Select;
const aPagination = Pagination;
const draggable = VueDraggableNext;

const token = getToken();
const gatewayId = router.currentRoute.value.params.gatewayId;
const activeKey = ref(1);
const imgList: any = ref([]);
const content: any = ref({});

const myImages = ref();
const visible = ref<boolean>(false);
const saveImgList: any = ref([]);
myImages.value =
  props.custom.type == 6 || props.custom.type == 7
    ? { ...props.custom.tabsList[props.labelId].nestedList[0] }
    : { ...props.custom };
myImages.value.imgList.length > 0 ? (saveImgList.value = [...myImages.value.imgList.filter((e: any) => e.url != '')]) : '';
content.value = { ...myImages.value.content };
/**
 * 立即上传
 */
const { file, fileList, loading, flieLink, beforeUpload, handleChange } = uploadNow();
watch(
  () => flieLink.value,
  () => {
    activeKey.value == 1 ? add_portal_file(file.value, visible.value ? 2 : 1) : (content.value.bg_img = flieLink.value),
      toVisualization();
  }
);
/** */

const arrangementMode = ref([
  {
    name: 'images_style_1',
    value: 1,
  },
  {
    name: 'images_style_2',
    value: 2,
  },
  {
    name: 'images_style_3',
    value: 3,
  },
  {
    name: 'images_style_4',
    value: 4,
  },
]);

const toVisualization = () => {
  saveImgList.value.length > 0 ? (myImages.value.imgList = saveImgList.value) : '';
  myImages.value.content = content.value;
  if (props.custom.type == 6 || props.custom.type == 7) {
    const custom = { ...props.custom };
    custom.tabsList[props.labelId].nestedList[0] = { ...myImages.value };
    emitter.emit('visualization', custom);
  } else {
    emitter.emit('visualization', myImages.value);
  }
};

const iconVisible = ref<boolean>(false);
const iconModal = ref();
const onClose = () => {
  iconVisible.value = !iconVisible.value;
};

const iconOrBg = ref();
emitter.on('selectIconOrBg', (e: any) => {
  iconOrBg.value = e;
});
const onOK = () => {
  if (!iconOrBg.value) {
    iconVisible.value = false;
  } else if (iconOrBg.value.length > 1) {
    message.error('请勾选一个' + iconTips.value + '添加');
  } else {
    iconVisible.value = !iconVisible.value;
    content.value.bg_img = iconOrBg.value[0];
  }
};
const iconTips = ref();
const openModal = (type: string) => {
  type == 'icon' ? (iconTips.value = '图标') : (iconTips.value = '背景');
  emitter.emit('iconTips', iconTips.value);
  iconVisible.value = true;
};

const handleOk = () => {
  visible.value = false;
  // saveImgList.value.push(
  //   ...imgList.value
  //     .filter((e: any) => e.choice == true)
  //     .map((i: any) => {
  //       i.file_link;
  //     })
  // );
  imgList.value
    .filter((e: any) => e.choice == true)
    .map((i: any) => {
      saveImgList.value.push({
        id: i.id,
        url: i.file_link,
      });
    });
  toVisualization();
};
const delImg = (index: number) => {
  saveImgList.value.splice(index, 1);
  toVisualization();
};

const choice_all = ref<boolean>(false);

const classification = ref<menuItem[]>([]);
const sortId = ref();
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 17, // 每页条数
  totalSize: 1, // 总页数
  options: ['17', '29', '41', '53', '65'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

// 拖拽
const dragOptions = {
  animation: 0,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
};

// 获取分类列表
const getSortList = () => {
  let params = {
    type: 2,
    portal_id: gatewayId,
  };
  http.get_sort_list({ params }).then((res) => {
    classification.value = res.data.data;
    sortId.value = res.data.data[0].id;
    getFileList();
  });
};
getSortList();
const add_portal_file = async (file: any, type: number) => {
  let default_sort: any = classification.value.filter((e) => e.default == 1)[0];
  let params = {
    sort_id: type == 1 ? default_sort.id : sortId.value,
    name: file.name,
    type: 1,
    size: file.size,
    file_link: file.response.data.url,
    format: file.name.split('.')[1],
    dimensions: '100',
    portal_id: gatewayId,
  };
  await http
    .add_portal_file(params)
    .then((res: any) => {
      pageConfig.current = 1;
      if (type == 1) {
        saveImgList.value.unshift({
          id: res.data.data.id,
          url: res.data.data.file_link,
        });
        toVisualization();
      } else {
        getFileList();
      }
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
const showLoading = ref<boolean>(false);
// 获取列表
const getFileList = () => {
  showLoading.value = true;
  let filelist = {
    type: 1,
    sort_id: sortId.value,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    portal_id: gatewayId,
  };
  http
    .getFileList({ params: filelist })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      imgList.value = res.data.data.data;
      imgList.value.forEach((item: any) => (item.choice = false));
      showLoading.value = false;
      choice_all.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};
// 全选
const checkAll = () => {
  imgList.value.forEach((item: any) => (item.choice = choice_all.value));
};
const jump = () => {
  router.push('/site/picture/' + gatewayId);
};

const modalVisible = ref(false);
// 删除
const openDelModal = () => {
  modalVisible.value = true;
};
const closeDelModal = () => {
  modalVisible.value = false;
};
// 删除确定按钮
const studioIds: any = ref([]);
const removeLiveData = () => {
  imgList.value.map((item: any) => (item.choice ? studioIds.value.push(item.id) : ''));
  let delPortal = {
    id: studioIds.value.join(','),
    type: 1,
    portal_id: gatewayId,
  };
  http
    .getDelPortalFile({ params: delPortal })
    .then((res) => {
      pageConfig.current = 1;
      studioIds.value = [];
      getFileList();
      modalVisible.value = false;
      message.success(res.data.message);
    })
    .catch((res: any) => {
      message.error(res.data.error);
      modalVisible.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "iconModal",
    ref: iconModal
  }, [
    _createVNode(_unref(aTabs), {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[15] || (_cache[15] = ($event: any) => ((activeKey).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_unref(aTabPane), {
          key: 1,
          tab: "内容设置"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_a_input, {
                class: "setup_input",
                placeholder: "请输入主标题",
                maxlength: 6,
                value: content.value.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((content.value.title) = $event)),
                onChange: toVisualization
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(content.value.title.length) + "/ 6", 1)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(aInputNumber), {
                value: content.value.most,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((content.value.most) = $event)),
                onChange: toVisualization,
                class: "setup_title_number",
                min: 1,
                max: 10
              }, null, 8, ["value"]),
              _createVNode(_unref(aTooltip), { placement: "left" }, {
                title: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "setup_title_icon" })
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: "img_list w_box",
                style: _normalizeStyle(saveImgList.value.length == 0 ? 'height:175px' : '')
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(aUpload), {
                    "file-list": _unref(fileList),
                    "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                    name: "images",
                    "list-type": "picture-card",
                    class: _normalizeClass(["avatar-uploader", saveImgList.value.length == 0 ? 'upload_screen' : 'upload']),
                    "show-upload-list": false,
                    accept: ".jpg,.jpeg,.png,.gif",
                    action: "/api/v1/common/upload_images",
                    headers: { token: _unref(token) },
                    "before-upload": _unref(beforeUpload),
                    onChange: _unref(handleChange)
                  }, {
                    default: _withCtx(() => [
                      (_unref(loading))
                        ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                        : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["file-list", "class", "headers", "before-upload", "onChange"])
                ]),
                _createVNode(_unref(draggable), _mergeProps({
                  handle: ".mover",
                  class: "img_list draggable_box",
                  list: saveImgList.value
                }, dragOptions, {
                  disabled: saveImgList.value.length < 1,
                  onEnd: _cache[3] || (_cache[3] = ($event: any) => (toVisualization())),
                  onDrop: _unref(dragDrop)
                }), {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saveImgList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "img_item",
                        key: index,
                        style: _normalizeStyle({ marginLeft: index == 0 ? '101px' : '3px' })
                      }, [
                        _withDirectives(_createVNode(_component_svg_icon, {
                          class: "mover",
                          "icon-class": "drag_icon"
                        }, null, 512), [
                          [_vShow, saveImgList.value.length > 1]
                        ]),
                        _createVNode(_component_svg_icon, {
                          class: "delete_circular",
                          "icon-class": "delete_circular",
                          onClick: ($event: any) => (delImg(index))
                        }, null, 8, ["onClick"]),
                        _createElementVNode("img", {
                          src: item.url,
                          alt: ""
                        }, null, 8, _hoisted_10)
                      ], 4))
                    }), 128))
                  ]),
                  _: 1
                }, 16, ["list", "disabled", "onDrop"])
              ], 4),
              _createElementVNode("div", {
                class: "sel_img_upd flex center",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (visible.value = true))
              }, "选择上传")
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrangementMode.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: _normalizeClass(["flex center", { active: item.value == content.value.style }]),
                    key: index,
                    onClick: ($event: any) => ((content.value.style = item.value), toVisualization())
                  }, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": item.name
                    }, null, 8, ["icon-class"])
                  ], 10, _hoisted_14))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_unref(aTabPane), {
          key: 2,
          tab: "样式设置",
          "force-render": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_unref(aRadioGroup), {
                name: "radioGroup",
                value: content.value.title_type,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((content.value.title_type) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (toVisualization()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("默认")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("自定义")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(content.value.title_color), 1),
                _createVNode(_unref(ElColorPicker), {
                  modelValue: content.value.title_color,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((content.value.title_color) = $event)),
                  size: "mini",
                  predefine: _unref(colorList),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (toVisualization()))
                }, null, 8, ["modelValue", "predefine"])
              ])
            ], 512), [
              [_vShow, content.value.title_type == 1]
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_unref(aRadioGroup), {
                name: "radioGroup",
                value: content.value.bg_type,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((content.value.bg_type) = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (toVisualization()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("默认")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("自定义")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_a_button, {
                  class: "mod_modal_btn",
                  style: {"width":"140px"},
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (openModal('bg')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("我的背景")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aUpload), {
                  class: "modular_bottom_btn btn_border",
                  "file-list": _unref(fileList),
                  "onUpdate:fileList": _cache[12] || (_cache[12] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                  name: "images",
                  multiple: false,
                  action: "/api/v1/common/upload_images",
                  "before-upload": _unref(beforeUpload),
                  headers: { token: _unref(token) },
                  onChange: _unref(handleChange)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      class: "mod_modal_btn",
                      style: {"width":"140px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("立即上传")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "before-upload", "headers", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (i, j) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: _normalizeStyle({ background: i }),
                    key: j,
                    onClick: ($event: any) => ((content.value.bg_color = i), toVisualization())
                  }, null, 12, _hoisted_25))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", null, _toDisplayString(content.value.bg_color), 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: content.value.bg_color,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((content.value.bg_color) = $event)),
                    size: "mini",
                    predefine: _unref(colorList),
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (toVisualization()))
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ], 512), [
              [_vShow, content.value.bg_type == 1]
            ])
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(CIconModal, {
      title: `添加${iconTips.value}（只能添加jpg,jpeg,png,大小不超过3MB)`,
      visible: iconVisible.value,
      close: onClose,
      ok: onOK,
      getContainer: () => iconModal.value
    }, null, 8, ["title", "visible", "getContainer"]),
    _createVNode(_unref(aModal), {
      centered: "",
      visible: visible.value,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((visible).value = $event)),
      width: "910px",
      title: "分类选择（只能添加jpg,jpeg,png,大小不超过3MB 建议尺寸：1980px*1080px)",
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createTextVNode("图片分类： "),
            _createVNode(_unref(aSelect), {
              ref: "select",
              value: sortId.value,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((sortId).value = $event)),
              style: {"width":"120px"},
              onChange: _cache[17] || (_cache[17] = ($event: any) => (getFileList()))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classification.value, (i) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: i.id,
                    value: i.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(i.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_a_checkbox, {
              class: "select",
              checked: choice_all.value,
              "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((choice_all).value = $event)),
              onChange: checkAll
            }, {
              default: _withCtx(() => [
                _createTextVNode("全选")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_a_button, {
              type: "link",
              danger: "",
              disabled: imgList.value.filter((e) => e.choice == true).length == 0 ? true : false,
              onClick: openDelModal
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "mod_btn_icon",
                  "icon-class": "del"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 删除 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          (showLoading.value)
            ? (_openBlock(), _createBlock(CLoading, {
                key: 0,
                style: {"height":"280px","padding-top":"120px"}
              }))
            : (imgList.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("p", null, [
                    _createTextVNode("暂时还没有添加照片！去内容中心"),
                    _createElementVNode("span", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (jump()))
                    }, "添加")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_unref(aUpload), {
                    "file-list": _unref(fileList),
                    "onUpdate:fileList": _cache[20] || (_cache[20] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                    name: "images",
                    "list-type": "picture-card",
                    class: "avatar-uploader upload",
                    "show-upload-list": false,
                    accept: ".jpg,.jpeg,.png,.gif",
                    action: "/api/v1/common/upload_images",
                    headers: { token: _unref(token) },
                    "before-upload": _unref(beforeUpload),
                    onChange: _unref(handleChange)
                  }, {
                    default: _withCtx(() => [
                      (_unref(loading))
                        ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                        : (_openBlock(), _createElementBlock("img", _hoisted_37)),
                      _hoisted_38
                    ]),
                    _: 1
                  }, 8, ["file-list", "headers", "before-upload", "onChange"]),
                  _createVNode(_unref(draggable), {
                    handle: ".mover",
                    class: "modal_img_list draggable",
                    list: imgList.value,
                    disabled: imgList.value.length < 1,
                    onDrop: _unref(dragDrop)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "img_item",
                          key: index,
                          style: _normalizeStyle({ marginLeft: index == 0 ? '150px' : '' })
                        }, [
                          _createElementVNode("img", {
                            src: item.file_link,
                            alt: ""
                          }, null, 8, _hoisted_39),
                          _createElementVNode("div", {
                            class: "hover_top flex between",
                            style: _normalizeStyle(item.choice ? 'display:block' : '')
                          }, [
                            _createVNode(_component_a_checkbox, {
                              class: "select",
                              checked: item.choice,
                              "onUpdate:checked": ($event: any) => ((item.choice) = $event)
                            }, null, 8, ["checked", "onUpdate:checked"]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              class: "mover",
                              "icon-class": "drag_icon"
                            }, null, 512), [
                              [_vShow, imgList.value.length > 1]
                            ])
                          ], 4),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(item.name), 1)
                        ], 4))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["list", "disabled", "onDrop"])
                ])),
          _createVNode(_unref(aPagination), {
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[21] || (_cache[21] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[22] || (_cache[22] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-quick-jumper": "",
            onChange: _cache[23] || (_cache[23] = ($event: any) => (getFileList())),
            onShowSizeChange: _cache[24] || (_cache[24] = ($event: any) => (getFileList()))
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: modalVisible.value,
      centered: "",
      close: closeDelModal,
      ok: removeLiveData
    }, null, 8, ["visible"])
  ], 512))
}
}

})